import script from "./templateBigScreen3.vue?vue&type=script&setup=true&lang=js"
export * from "./templateBigScreen3.vue?vue&type=script&setup=true&lang=js"

import "./templateBigScreen3.vue?vue&type=style&index=0&id=395cdef3&lang=less"

const __exports__ = script;

export default __exports__